// ===== SRC/MAIN.JS =====
import "./styles/ui.css";
import { App } from "./App.js";

// Initialiser l'application
const app = new App();
app.mount("#app");
window.app = app;
